<ng-container *ngIf="dynamicHeaderComponent && dynamicFooterComponent">
  <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_footer_issue_in_all_stores'];else normalLayout">
    <div class="layout-container">
      <ng-container *ngComponentOutlet="dynamicHeaderComponent"></ng-container>
      <mat-sidenav-container [ngClass]="themeType == 'Hudson' ? 'main-container hudsonMilkTheme' : 'main-container'">
      <div class="theme-container main" [class.fullW]="isCmsView">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-container>
      <ng-container *ngComponentOutlet="dynamicFooterComponent"></ng-container>
    </div>
  </ng-container>
  <ng-template #normalLayout>
    <ng-container *ngComponentOutlet="dynamicHeaderComponent"></ng-container>
      <mat-sidenav-container [ngClass]="themeType == 'Hudson' ? 'main-container hudsonMilkTheme' : 'main-container'">
      <div class="theme-container main" [class.fullW]="isCmsView">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-container>
      <ng-container *ngComponentOutlet="dynamicFooterComponent"></ng-container>
  </ng-template>
</ng-container>
<!-- [ngClass]="themeType == 'Hudson' ? 'dTheme' : 'cTheme'" -->

<button class="order-summary-global-mobile" *ngIf="isorderSummery && loggedIn" (click)="toggleDrawer()">
  <div class="pullOpen">
    <svg width="124" height="21" viewBox="0 0 124 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M107.251 3.41379C105.175 1.23382 102.296 0 99.2857 0H25.1429C21.8587 0 18.7181 1.34598 16.4532 3.72414L0 21H124L107.251 3.41379Z" fill="#08901B"/>
      <path d="M55.3749 16.1921H69.6249C69.7692 16.1919 69.9106 16.1675 70.0339 16.1218C70.1573 16.0761 70.2579 16.0106 70.3249 15.9325C70.3919 15.8545 70.4228 15.7667 70.4143 15.6787C70.4057 15.5907 70.3581 15.5057 70.2764 15.4331L63.1514 9.1437C62.8561 8.88294 62.1452 8.88294 61.8491 9.1437L54.7241 15.4331C54.6417 15.5056 54.5933 15.5906 54.5843 15.6787C54.5753 15.7669 54.606 15.8549 54.6731 15.9331C54.7402 16.0114 54.841 16.0769 54.9648 16.1225C55.0885 16.1682 55.2303 16.1923 55.3749 16.1921Z" fill="white"/>
    </svg>        
  </div>
  <div class="pull-up-text">
    <img src="assets/images/truck_delivery.png" alt="Truck Delivery">
    Pull to Check Order Summary
  </div>
</button>
<ng-container *ngIf="isorderSummery && loggedIn">
  <app-order-summary class="order-summary-global"></app-order-summary>
</ng-container>

<div *ngIf="showBackToTop" fxLayout="row" fxLayoutAlign="center center" class="back-to-top transition">
  <button mat-icon-button (click)="scrollToTop()" style="background-color: white;">
      <mat-icon class="align-font">arrow_upward</mat-icon>
  </button>
</div>